import React from 'react';
import OrderListTable from "../../../components/OrderListTable";
import {ShippingStatus} from "../../../../types/order";

export const ExchangeAllOrderPage = () => {
    return <OrderListTable status={ShippingStatus.CHANGE}/>;
}
